<div class="header flex-row d-flex align-items-center">

    <div class="header-icon">
        <img appImageSelector alt="mt-image" [imageKey]="config.imageKey" [imageType]="config.imageType">
    </div>

    <div class="header-content">
        <div class="title">
            {{config.title | lang}}
        </div>    

        <div class="subtitle">
            {{config.subtitle | lang}} <span *ngIf="config.date">({{config.date | datePresentation}})</span>
        </div>
    </div>
</div>